import { useState, useEffect, useRef } from 'react';

const MIN_MS = 700;

export function useMinLoading(isLoading: boolean): boolean {
  const [show, setShow] = useState(false);
  const startRef = useRef(0);

  useEffect(() => {
    if (isLoading) {
      startRef.current = Date.now();
      setShow(true);
      return;
    }
    const elapsed = Date.now() - startRef.current;
    const remaining = Math.max(0, MIN_MS - elapsed);
    const id = setTimeout(() => setShow(false), remaining);
    return () => clearTimeout(id);
  }, [isLoading]);

  return show;
}
